import { useUrlState } from '@/hooks/useUrlState';
import { NightCalendarPage } from './NightCalendarPage';
import { NightsGridPage } from './NightsGridPage';
import { nightsLayoutUrlSchema } from './nightsGridUrlState';

/** `/nights`: the night calendar (the default) or, with `?layout=grid`, the grid of upcoming nights. */
export function NightsPage() {
  const { state } = useUrlState(nightsLayoutUrlSchema);
  return state.layout === 'grid' ? <NightsGridPage /> : <NightCalendarPage />;
}
